module.exports = __webpack_public_path__ + "static/media/roble_assago.69d23cf2.jpg";